
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 76 76"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.65 26.6L57 34.2l-6.65-7.6h4.75v-5.7a3.8 3.8 0 0 0-3.8-3.8h-19v-3.8h19a7.6 7.6 0 0 1 7.6 7.6v5.7zM20.9 57a3.8 3.8 0 0 1-3.8-3.8v-5.7h4.75l-6.65-7.6-6.65 7.6h4.75v5.7a7.6 7.6 0 0 0 7.6 7.6H38V57zm9.5-48.45a2.86 2.86 0 0 0-2.85-2.85h-17.1A2.86 2.86 0 0 0 7.6 8.55v24.7a2.86 2.86 0 0 0 2.85 2.85h17.1a2.86 2.86 0 0 0 2.85-2.85zM46.69 65a4.34 4.34 0 0 1-3-4V39.9a1.9 1.9 0 0 0-1.9 1.9v24.7a1.9 1.9 0 0 0 1.9 1.9H58zM64.6 39.71a2.3 2.3 0 0 0-1.66-2.12l-15.68-3.93A1.28 1.28 0 0 0 45.6 35v26a2.45 2.45 0 0 0 1.64 2.2L63 67.91a1.21 1.21 0 0 0 1.64-1.22z","fill":"#fff"}})])
          )
        }
      }
    